/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="container user-avatar">
      <h1>angles of triangles</h1>
    </header>
  );
}
export default Header;
